const request = {
    invalid_input: '输入无效。{{details}}',
    general: '发生请求错误。',
};
export default Object.freeze(request);
